import { render, staticRenderFns } from "./UnshareItemModal.vue?vue&type=template&id=3b0832aa"
import script from "./UnshareItemModal.vue?vue&type=script&lang=js"
export * from "./UnshareItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports